import { PatientsBoolExp } from '@eluve/graphql-types';

/**
 * Reads the "include inactive/deceased" state out of the data-table filter
 * URL params. The toggle is stored as the faceted-filter array `['true']`.
 */
export const isShowingFlaggedPatients = (
  filters: Record<string, string | string[] | null>,
): boolean =>
  Array.isArray(filters.isFlagged) && filters.isFlagged.includes('true');

/**
 * Deceased / left-practice patients (ENG-5377 mirror columns) are hidden
 * unless the toggle is on. Both columns are NULL for tenants without the
 * patient-profile feature, so the default exclusion is a no-op there.
 */
export const buildPatientsListFilter = ({
  showFlagged,
}: {
  showFlagged: boolean;
}): PatientsBoolExp | null =>
  showFlagged
    ? null
    : { deceasedAt: { _isNull: true }, deactivatedAt: { _isNull: true } };
